import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../Themes';

import styles from './MyUpgradeSelection.Styles';

const MyUpgradeSelection = ({ onEditSelectionPress }) => {
  const theme = useTheme();
  const images = getThemeImages(theme.name);

  return (
    <View style={styles.container}>
      <VFText
        style={styles.upgradeSelection}
        i18nKey={'device_upgrade_summary_step_my_upgrade_selection'}
      />
      <TouchableWithoutFeedback onPress={onEditSelectionPress}>
        <View style={styles.editContainer}>
          <VFText
            i18nKey={'device_upgrade_summary_step_edit'}
            type={'textWithIcon'}
            style={styles.editText}
          />
          <Icon size={24} name={images.edit_pen} />
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};
MyUpgradeSelection.propTypes = {
  onEditSelectionPress: PropTypes.func,
};
export default MyUpgradeSelection;
